import {
  ContratosCorreccionPara,
  EstadoPreventaEnum,
  EstadosContratoChoiceEnum,
  gridSizeMdLg1,
  gridSizeMdLg11,
  gridSizeMdLg12,
  gridSizeMdLg5,
  gridSizeMdLg6,
  ModulosEnumChoice,
} from "@/shared";
import {
  useFetchContratos,
  useFetchMotivosRechazo,
} from "@/shared/actions/erp";
import {
  CustomAutocompleteArrString,
  SingleIconButton,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import CustomRangeDate from "@/shared/components/ui/CustomRangeCalendar";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { useTableColumnsPreventa } from "@/shared/hooks/useTableColumnsPreventa";
import { Contrato } from "@/shared/interfaces";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Grid } from "@mui/material";
import dayjs from "dayjs";
import { ReactNode, useState } from "react";
import { FieldError, useForm } from "react-hook-form";

export type FormMotivosFiltro = {
  motivocorreccioncontrato: string;
};

export default function PendienteActualizarOperacion() {
  const [dateRange, setDateRange] = useState<[string, string]>([dayjs().subtract(1, 'week').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]);
  //HOOK PERSONALIZADO
  const { columnsPlantaExternaContratosNovedades } = useTableColumnsPreventa(
    EstadoPreventaEnum.EN_ESPERA
  );

  const form = useForm<FormMotivosFiltro>({
    // defaultValues: {
    //   contratoState: EstadosContratoChoiceEnum.ALL,
    //   estadoInformacionContrato: EstadosActualizacionContratoEnum.ALL,
    // },
  });
  const watchedMotivoCorreccion = form.watch("motivocorreccioncontrato", "");
  const { errors } = form.formState;
  const {
    data: motivosCorreccionContrato,
    isLoading: isLoadingMotivosCorreccionContrato,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.CONTRATOS,
    page_size: 256,
    nombre: "TECNICO",
  });

  const { pagination, setPagination } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    data: contratosPagingRes,
    isLoading: isLoadingContratos,
    isRefetching: isRefetchingContratos,
  } = useFetchContratos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      estado_actualizacion_in: `${EstadosContratoChoiceEnum.SOLICITUD_CORRECCION},${EstadosContratoChoiceEnum.CORREGIDO}`,
      correccion_para_in: `${ContratosCorreccionPara.TECNICO},${ContratosCorreccionPara.VENTAS_TECNICO}`,
      order_by: "fecha_modificacion",
      order_up: true,
      ultimos_motivos_correccion: watchedMotivoCorreccion,
      fecha_hora_instalacion_range_after: dateRange?.[0] || undefined,
      fecha_hora_instalacion_range_before: dateRange?.[1] || undefined,
      ...filterObject,
    },
  });


  return (
    <SingleTableBoxScene
      title={"Pendiente Actualizar Técnico"}
      visibleReport={true}
    >
      {/* <Grid container spacing={2}> */}
        <Grid {...gridSizeMdLg12} container item justifyContent="flex-start" alignItems="center">
          <Grid {...gridSizeMdLg6} container >
            {/* <CustomSearch
                enableSearch={false}
                onChange={onChangeFilter}
                value={globalFilter}
                text="por Identificacion"
                onChangeRangeDate={onChangeRangeDate}
                cleanFilter={cleanFilter}
              /> */}
            <CustomAutocompleteArrString
              size={gridSizeMdLg11}
              label="Motivo Corrección"
              name="motivocorreccioncontrato"
              control={form.control}
              defaultValue={form.getValues().motivocorreccioncontrato || ""}
              options={
                motivosCorreccionContrato?.data?.data
                  ?.map((item) => item.nombre)
                  ?.concat([""])!
              }
              isLoadingData={isLoadingMotivosCorreccionContrato}
              error={errors.motivocorreccioncontrato as FieldError}
              helperText={errors.motivocorreccioncontrato?.message as ReactNode}
              disableClearable
            />
            <SingleIconButton
              size={gridSizeMdLg1}
              startIcon={<FilterAltOffIcon />}
              onClick={() => {
                form.setValue("motivocorreccioncontrato", "");
              }}
            />
        </Grid>



        <Grid {...gridSizeMdLg6} container item justifyContent="flex-end" alignItems="center">
          <CustomRangeDate
            // onChange={(val) => {console.log(val)}}
            
            defaultValue={dateRange}
            label="Fecha instalacion"
            onChangeRangeDate={(val) => { setDateRange([dayjs(val[0]).format('YYYY-MM-DD'), dayjs(val[1]).format('YYYY-MM-DD')]); }}
            cleanFilter={() => setDateRange(["",""])}
            // custom_options={{
            //   minDate: "today",
            //   maxDate: dayjs().add(1, 'month').toDate(),
            // }}
          />
        </Grid>


        <Grid {...gridSizeMdLg12} container item xs={12}>
          <GeneralTable<Contrato>
            columns={columnsPlantaExternaContratosNovedades}
            data={contratosPagingRes?.data.data || []}
            isLoading={isLoadingContratos}
            isRefetching={isRefetchingContratos}
            enableGlobalFilter={false}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={contratosPagingRes?.data?.count}
            actionsColumnSize={120}
            canDelete={false}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            enableEditing={false}   

            
          />
        </Grid>
      </Grid>
    </SingleTableBoxScene>
  );
}
